import { EmptyMessage as EmptyMessageComponent } from './EmptyMessage';

export const EmptyMessage = EmptyMessageComponent;
